/* eslint-disable */
import {
  Layout,
  Card,
  Typography,
  Space,
  Flex,
  Button,
} from "antd";
import React, { useEffect, useRef, useState } from "react";
import {
  PlusOutlined,
} from "@ant-design/icons";
import api from "@/utils/api";
import http from "@/utils/http";
import moment from "moment";
import { CustomTable } from "@/hocComponents";
import commonFn from "@/utils/commonFn";
import AddModal from "./component/addModal";
export default function ApprovalRequest() {
  const { Header, Content } = Layout;
  const { Title } = Typography;
  const addModalRef = useRef(null);

  // 默认选中的值
  const [selectedItems, setSelectedItems] = useState([]);
  const [options, setOptions] = useState([]);
  const [columns, setColumns] = useState([]);
  const [refreshKey, setRefreshKey] = useState(0);
  const [tableList, setTableList] = useState([]);
  const [tableLoading, setTableLoading] = useState(false);

  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 25,
    total: 0,
  });
  // table
  const initTableHead = {
    trust: null,
    groupCode: null,
    property: null,
    amount: null,
    otherAmount: null,
    batchNumber: null,
    glAcct: null,
    remark: null,
    usid: null,
    dateStartSt: null,
    dateEndSt: null,
  };
  const [tableHead, setTableHead] = useState(initTableHead);

  const tableFilterFn = (event, key, type = "Input") => {
    commonFn.tableFilterFn({ event, key, type, setTableHead, getTableListFn });
  };

  const initColumns = [
    {
      title: "Entity",
      dataIndex: "trust",
      // titleType: "Input",
      width: 100,
      // onChange: (e) => tableFilterFn(e, "prop"),
    },
    {
      title: "# Of Prop",
      dataIndex: "checkAmount",
      width: 100,
    },

    {
      title: "Monthly",
      dataIndex: "monthlyPayment",
      width: 100,
    },
   {
      title: "ACH Account",
      dataIndex: "checkNumber",
      width: 100,
    },
    {
      title: "Current Loan",
      dataIndex: "currentLoan",
    },
    {
      title: "Original Loan",
      dataIndex: "originalLoan",
    },
      {
      title: "Lender",
      dataIndex: "vendorName",
    },
    {
      title: "Loan Number",
      dataIndex: "loanNumber",
    },
    {
      title: "Interest Rate",
      dataIndex: "interestRate",
    },
    {
      title: "Loan Date",
      dataIndex: "loanDate",
      // titleType: "DatePicker",
      // onChange: (e) => tableFilterFn(e, "clearedDate", "DatePicker"),
      render: (text) => (text ? moment(text).format("MM/DD/YYYY") : " - "),
    },
    {
      title: "Maturity",
     dataIndex: "loanEndDate",
      // titleType: "DatePicker",
      // onChange: (e) => tableFilterFn(e, "clearedDate", "DatePicker"),
      render: (text) => (text ? moment(text).format("MM/DD/YYYY") : " - "),
    },

    {
      title: "Fix/Variable",
      dataIndex: "fixRate",
    },

   {
      title: "Swap/Fix End Date",
      dataIndex: "fixEndDateStr",
      width:150,
      // titleType: "DatePicker",
      // onChange: (e) => tableFilterFn(e, "clearedDate", "DatePicker"),
      // render: (text) => (text ? moment(text).format("MM/DD/YYYY") : " - "),
    },
    {
      title: "Term/ Amort",
      dataIndex: "termPeriod", 
    },
    {
      title: "Variable Index",
      dataIndex: "variableIndex",
    },
     {
      title: "Margin",
      dataIndex: "marginRate",
    },
       {
      title: "Loan Type",
      dataIndex: "loanType",
    },
          {
      title: "Recourse",
      dataIndex: "recourse",
    },
  ];



  // 获取列表数据
  const getTableListFn = async (current, pageSize, tableHead = {}) => {
    setTableLoading(true);
   
   const params = {
      page: current || pagination.current,
      count: pageSize || pagination.pageSize,
      ...tableHead,
    };
    try {
  const response = await http.post(`${api.getMortgageRollingList}`, params);
      if (response?.code !== "1") {
        commonFn.modalFailedFn(response);
        return;
      }

      const list = (response.data.list || []).map((item, index) => ({
        ...item,
        "#": index + 1,
      }));
    setPagination((prev) => ({
      ...prev,
      total: response.data.total || 0,
      current: params.page,
      pageSize: params.count,
    }));
      setTableList(list);
    } finally {
      setTableLoading(false);
   
    }
  };

 const handleTableChange = (pagination, filters, sorter) => {
    getTableListFn(pagination.current, pagination.pageSize, tableHead);
  };

  const initColunmsFn = () => {
    setTableHead(initTableHead);
    setColumns(initColumns);
    const transformedList = initColumns.map((item) => ({
      label: item.title,
      value: item.dataIndex,
    }));
    setOptions(transformedList);
    const transformedList2 = initColumns.map((item) => item.dataIndex);
    setSelectedItems(transformedList2);
  };

  const showModal = () => {
    addModalRef.current?.setModelAdd();
  };


   useEffect(() => {
     initColunmsFn();
     getTableListFn(1, 25);
   }, [refreshKey]);
    
  return (
    <div className="dashboard-layout">

      <Content style={{ marginTop: 10 }}>
     
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              padding: "10px 0",
              alignItems: "center",
            }}
          >
            <div style={{ fontWeight: "bold", fontSize: 16 }}>
              {/* View All Bank Transactions */}
            </div>

         <Flex className="topDiv" justify="space-between" align="flex-start">
        <div>
          <Button className="btnNew" onClick={showModal}>
            <PlusOutlined />
            New
          </Button>
        </div>
        </Flex>
          </div>

          {/* 表格 */}
          <CustomTable
            refreshKey={refreshKey}
            tableLoading={tableLoading}
            columns={columns.filter((c) => !c.hidden)}
            tableList={tableList}
            handleTableChange={handleTableChange}
            rowKey={"#"}
            tableScrollY="350px"
            tableCss="maintenanceTable"
          />
      
          <AddModal
        ref={addModalRef}
        onSuccess={() => {
          getTableListFn(pagination.current, pagination.pageSize, tableHead);
        }}
      />


      </Content>
    </div>
  );
}
